import { computed, inject, Injectable, RendererFactory2, signal } from '@angular/core';
import { THEME } from '../constants';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly rendererFactory = inject(RendererFactory2);
  private readonly renderer = this.rendererFactory.createRenderer(null, null);

  theme = signal<string>('dark');
  lightMode = computed(() => this.theme() === 'light');

  async init(): Promise<void> {
    // const savedTheme = localStorage.getItem(THEME);
    // const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    // const theme = savedTheme ?? (systemPrefersDark ? 'dark' : 'light');
    const theme = 'light';
    this.theme.set(theme);
    this.renderer.setAttribute(document.body, 'data-theme', this.theme());
  }

  changeTheme(theme: 'light' | 'dark'): void {
    this.theme.set(theme);
    localStorage.setItem(THEME, this.theme());
    this.renderer.setAttribute(document.body, 'data-theme', this.theme());
  }

  forceDarkTheme(): void {
    this.renderer.setAttribute(document.body, 'data-theme', 'dark');
  }
}
